//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import peligroContext from '../../context/peligroContext/peligroContex';
import './FormPeligro.css';

function FormPeligro({data, setData, minimizar, nuevoEditado, handleChangePeligros, index, tDocID = '' }){

    const pContext = useContext(peligroContext);
    const {agregarPeligro, actualizarPeligroLista, modificarPeligro, eliminarPeligro} = pContext;

    const [peligro, setPeligro] = useState({codPeligro:"",name: ''});

    const [titulo, setTitulo] = useState(nuevoEditado);

    const validacion =  () => {
        const newErrors = {};
        if (peligro.codPeligro === '' || peligro.codPeligro === undefined) return newErrors.codigo = 'El código de peligro debe ser colocado'
        if (peligro.name === '' || peligro.name === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        return '';
    };

    const handlerGenerar = async ()  => {

        const errorAxi = validacion();

        if ( errorAxi === "" ) {

            try {
                const dato = peligro;
                const res = await agregarPeligro(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se guardo un nuevo Peligro`,
                        icon: 'success',
                        text: `Código: ${res.codPeligro} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarPeligroLista();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del Peligro",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "") {

            try {
                const dato = {
                    id: data.id,
                    codPeligro:peligro.codPeligro,
                    name: peligro.name
                }
                await setData(dato);
                const res = await modificarPeligro(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se modificó el Peligro`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codPeligro}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarPeligroLista();
                    minimizar();
                    let peligroToChange = {id:res._id, label:res.name, value:res.codPeligro, name:res.name};
                    handleChangePeligros(peligroToChange,index);
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del Peligro",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar este Peligro?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
                const id = data.id
                const resp = await eliminarPeligro(id, tDocID);
                if(resp.data.delete){
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `El Peligro fue borrado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizarPeligroLista();
                    handleChangePeligros({},index);
                    minimizar(null);
                }else{
                    Swal.fire({
                        title: `Operacion no puede realizarse`,
                        icon: 'error',
                        text: `${resp.data.msg}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                }
            } else if (result.isDismissed) {
                minimizar();
            }
        });
    }

    useEffect(()=>{
        if(data !== undefined){
            let codigoPeligro = (data.codPeligro != undefined) ? data.codPeligro : data.value;
            let peligroModelado = {id:data?.peligroID, codPeligro:codigoPeligro, name: data?.name};
            setPeligro(peligroModelado);
        }
    },[data])

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} Peligro
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de Peligro: </div>
                <input disabled={ titulo === "Modificar"} value={peligro.codPeligro} className='label-form-group-data' onChange={data => setPeligro({ ...peligro, ['codPeligro']:data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={peligro.name} className='label-form-group-data' onChange={data => setPeligro({ ...peligro, ['name']: data.target.value })} />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )
                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar()}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormPeligro;
